import { render, staticRenderFns } from "./taskinfo.vue?vue&type=template&id=593a8bd7"
import script from "./taskinfo.vue?vue&type=script&lang=js"
export * from "./taskinfo.vue?vue&type=script&lang=js"
import style0 from "./taskinfo.vue?vue&type=style&index=0&id=593a8bd7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports